/**
 * Custom variables that are common dependencies to other custom scripts for post pages. Assumes 
 * that the DOM has been loaded.
 */

/**
 * Name of the HTML attribute to use as a trigger for mutating the comment form when the value of 
 * the attribute changes.
 */
export const formMutationTriggerAttrName = 'data-state';

/**
 * Structural element that contains elements that are undisplayed by default and intended to be 
 * swapped out with displayed elements.
 */
export const backstageMainEle = document.querySelector('#backstage-main');

/**
 * Structural element that contains post follow-ons such as further reading recommendations, 
 * comments, and a subscribe form.
 */
export const afterPostBoxEle = document.querySelector('#after-post-box');

/**
 * Structural NodeList of widgets that allow for activating/showing each after-post pane.
 */
export const afterPostTabElesList = (afterPostBoxEle !== null) ? afterPostBoxEle.querySelectorAll('[role="tablist"] [role="tab"]') : null;

/**
 * Structural element that contains everything comment-related for a post.
 */
export const commentPaneEle = document.querySelector('#comment-pane');

/**
 * Structural element that contains the user-submitted comments for a post.
 */
export const commentsBoxEle = (commentPaneEle !== null) ? commentPaneEle.querySelector('#comments-box') : null;

/**
 * Structural element that contains the comment-submission form.
 */
export const commentFormBoxEle = (commentPaneEle !== null) ? commentPaneEle.querySelector('#comment-form-box') : null;

/**
 * The comment-submission form.
 */
export const commentFormEle = (commentFormBoxEle !== null) ? commentFormBoxEle.querySelector('#comment-form') : null;

/**
 * One "reply" link per approved comment.
 */
export const commentReplyLinks = (commentsBoxEle !== null) ? commentsBoxEle.querySelectorAll('.comment-reply-link') : null;

/**
 * One "cancel reply" link re-used across the page, put into use if/when the user clicks the 
 * "reply" link accompanying each approved comment.
 */
export const commentReplyCancelLinkEle = document.querySelector('.comment-reply-cancel-link');
